export const marTerms = {
  listUsd: 10000,
  singlePaymentUsd: 8000,
  totalWeeks: 10,
  clientHours: 16,
  validUntil: "30 de noviembre de 2026",
  stages: [
    { name: "Escucha", weeks: 2, time: "1 hora" },
    { name: "Esencia", weeks: 3, time: "4 a 5 horas" },
    { name: "Dirección", weeks: 3, time: "Unas 8 horas" },
    { name: "Transferencia", weeks: 2, time: "2 a 3 horas" },
  ],
};
export const marDiscountPct = Math.round((1 - marTerms.singlePaymentUsd / marTerms.listUsd) * 100);
export const marStageWeeks = marTerms.stages.reduce((s, x) => s + x.weeks, 0);
export const formatUsd = (n: number) => n.toLocaleString("es-AR");
